import React from 'react';
import './LoadingSpinner.css';

export default function LoadingSpinner({ message = 'Loading…' }) {
  return (
    <div className="spinner-wrapper">
      <div className="spinner" aria-hidden="true" />
      <p className="spinner-message">{message}</p>
    </div>
  );
}
